<div fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="50px">
    <span>{{"NEED_TO_LOGIN" | translate}}</span>
    <button mat-flat-button color="primary" class="my-button" routerLink="/auth" type="button">{{"LOGIN" | translate}}</button>
</div>